/**
 * PREVIEW / MOCK-ONLY. Do NOT import from outside
 * `apps/carrier-dashboard/src/pages/MyOrders/preview/`. See
 * `./README.md` for the rules and the promotion path.
 */
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@hero/web-components';
import type { MockOrder, MockViewerRole } from './types';
import { QuickActions } from './cards';
import { OverviewTab, TimelineTab, PhotosTab, ActivityTab } from './tabs';

export interface ExpandedOrderRowProps {
  order: MockOrder;
  viewer: MockViewerRole;
}

/**
 * The expanded panel under a clicked row. Wraps four tabs:
 *
 *   Overview - Price / Driver / Load / Parties cards (the default).
 *   Timeline - Vertical event timeline (creation, contracts, pickup,
 *              delivery).
 *   Photos   - POD + supporting photo grid (placeholder thumbnails).
 *   Activity - Audit-log feed with absolute / commercial / system
 *              scope pills (driver viewer hides commercial).
 *
 * `QuickActions` sits below the tabs and stays visible on every tab
 * so the action strip never disappears mid-read.
 */
export const ExpandedOrderRow: React.FC<ExpandedOrderRowProps> = ({
  order,
  viewer,
}) => {
  return (
    <div className="bg-gray-50/60 px-4 py-4">
      <Tabs defaultValue="overview" className="w-full">
        <TabsList className="bg-white shadow-sm ring-1 ring-gray-200">
          <TabsTrigger value="overview">Overview</TabsTrigger>
          <TabsTrigger value="timeline">Timeline</TabsTrigger>
          <TabsTrigger value="photos">Photos</TabsTrigger>
          <TabsTrigger value="activity">Activity</TabsTrigger>
        </TabsList>

        <TabsContent value="overview" className="mt-3">
          <OverviewTab order={order} viewer={viewer} />
        </TabsContent>
        <TabsContent value="timeline" className="mt-3">
          <TimelineTab order={order} />
        </TabsContent>
        <TabsContent value="photos" className="mt-3">
          <PhotosTab order={order} />
        </TabsContent>
        <TabsContent value="activity" className="mt-3">
          <ActivityTab order={order} viewer={viewer} />
        </TabsContent>
      </Tabs>

      <div className="mt-3">
        <QuickActions order={order} viewer={viewer} />
      </div>
    </div>
  );
};
